import React from 'react'
import Tooltip from 'APP/Components/Tooltip'
import I18n from 'APP/I18n'
import {
  Container,
  DailyBreakDownContainer,
  DailyBreakDownMinutes,
  DailyBreakDownSubheader,
  DailyBreakDownWeekday,
  DayContainer,
  DayLabel,
  Dot,
  ProgressPillContainer,
  ProgressPillFill,
} from './style'
import moment from 'moment'

interface DailyBreakDownProps {
  currendDayText: string
  dailyGoalMessage: string
  acitveMinutes: number
}

const DailyBreakDown: React.FC<DailyBreakDownProps> = ({
  currendDayText,
  dailyGoalMessage,
  acitveMinutes,
}) => {
  return (
    <DailyBreakDownContainer testID="dailyBreakdown">
      <DailyBreakDownWeekday variant="subheaderBold" color="textInverted">
        {currendDayText}
      </DailyBreakDownWeekday>
      <DailyBreakDownMinutes variant="h2" color="textInverted">
        {I18n.t('ActiveMinutes.dailyProgress.dailyBreakdown.title', { count: acitveMinutes })}
      </DailyBreakDownMinutes>
      <DailyBreakDownSubheader variant="subheader" color="textInverted">
        {dailyGoalMessage}
      </DailyBreakDownSubheader>
    </DailyBreakDownContainer>
  )
}

interface ProgressPillProps {
  disabled: boolean
  progress?: number
}

const ProgressPill: React.FC<ProgressPillProps> = ({ disabled, progress = 0 }) => (
  <ProgressPillContainer disabled={disabled}>
    <ProgressPillFill grow={disabled ? 0 : progress / 100} />
  </ProgressPillContainer>
)

interface DailyProgressData {
  date: string
  minutes: number
  percentage: number
}

interface DailyProgressProps {
  dailyProgress?: DailyProgressData[]
  dailyGoal?: number
}

const weekDays = [1, 2, 3, 4, 5, 6, 7]
const DailyProgress: React.FC<DailyProgressProps> = ({ dailyProgress, dailyGoal }) => {
  return (
    <Container testID="dailyProgress">
      {weekDays.map((i) => {
        const progress = (dailyProgress || []).find(
          ({ date }) => moment(date, I18n.t('DateFormat')).isoWeekday() === i
        )
        const todaysWeekDay = moment().isoWeekday()
        const currentWeekDayLabel = moment.weekdays(i)
        const isCurrent = i === todaysWeekDay
        const isAfterCurrent = i > todaysWeekDay
        return (
          <Tooltip
            key={i}
            disabled={isAfterCurrent}
            testID={'dailyBreakdownTooltip'}
            analyticsName={`Daily progress ${currentWeekDayLabel}`}
            containerStyle={{}}
            content={
              <DailyBreakDown
                currendDayText={currentWeekDayLabel}
                dailyGoalMessage={I18n.t('ActiveMinutes.dailyProgress.goal', {
                  dailyGoal: dailyGoal || 0,
                })}
                acitveMinutes={progress?.minutes || 0}
              />
            }
          >
            <DayContainer>
              <ProgressPill disabled={isAfterCurrent} progress={progress?.percentage} />
              <DayLabel
                variant={isCurrent ? 'subheaderBold' : isAfterCurrent ? 'bodyNormal' : 'subheader'}
                isDisabled={isAfterCurrent}
              >
                {currentWeekDayLabel.charAt(0)}
              </DayLabel>
              {isCurrent && <Dot testID="dot" />}
            </DayContainer>
          </Tooltip>
        )
      })}
    </Container>
  )
}

export default DailyProgress
